import React, { FC } from "react";
import { ChatDetail } from "../../store/ChatAction";
import { ChatUserInfo } from "@xapp/stentor-chat-widget";
import { ROUTER_USER } from "../../xapp/StentorRouterChat";

export interface Props {
    readonly message: ChatDetail;
    readonly time?: string;
}

function isServerUser(user: ChatUserInfo): boolean {
    return user.nick?.endsWith(ROUTER_USER);
}

function getMessageByType(msg: ChatDetail) {
    switch (msg.type) {
        case "chat.memberjoin":
            return `${msg.user.displayName || "Bot"} has joined the chat`;
        case "chat.memberleave":
            return `${msg.user.displayName || "Bot"} has left the chat`;
        case "chat.rating":
            if (!msg.newRating) {
                return "You have removed the chat rating";
            } else {
                const rating = convertToSentenceCase(msg.newRating);
                return `You have rated the chat service ${rating}`
            }
        default:
            return JSON.stringify(msg);
    }
}

const SystemMessage: FC<Props> = props => {
    if (!isServerUser(props.message.user)) {
        return (
            <div className="system-msg-container">
                <span className="message-sr-only">{"at " + props.time + " system message"}</span>
                <span className="system-msg">{getMessageByType(props.message)}</span>
            </div>
        );
    } else {
        return null; 
    }
}

function convertToSentenceCase(s: string) {
    return s[0].toUpperCase() + s.slice(1);
}

export default SystemMessage;
